import templateUrl from "emun.customer/merge/customer-merge.htm";
import basicController from "servicestack/basic.controller.properties";
import customerConfig from "emun.customer/customer.config";
import authConfig from "emun.auth/auth.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import CustomerPicker from 'emun.customer/picker/customer-picker'
import ServiceBus from 'servicestack/service-bus'
import modals from "webmodals/modals";

class CustomerMergeController {
	constructor($scope) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = customerConfig;
		$ctrl.authConfig = authConfig;
		$ctrl.bus = new ServiceBus();
		$ctrl.pendingRetailersMaster = new AutoQuery({
			url: 'QueryCustomerMergeList.json',
			criteria: {
				IsProcessed: false,
				IsMaster: true
			},
			pageSize: 10,
			take: 10,
			hideLeftNav: true,
			autoLoad: true
		});
		$ctrl.pendingRetailersList = new AutoQuery({
			url: 'QueryCustomerMergeList.json',
			criteria: {
				IsProcessed: false,
			},
			pageSize: 10,
			take: 10,
			hideLeftNav: true,
			autoLoad: false
		});
		// $ctrl.pendingMerges = new AutoQuery({
		// 	url: "QueryCustomerMergeList.json",
		// 	criteria: {
		// 		IsProcessed: false
		// 	},
		// 	take: 1000,
		// 	autoLoad: true,
		// 	onLoaded: (args) => {
		// 		if (args.results.length) {
		// 			$ctrl.pendingMasterIds = args.results.filter(r => r.isMaster).map(obj => {return(obj.retailerId)}).join(",");
		// 			$ctrl.pendingRetailersMaster.criteria.IdIn = $ctrl.pendingMasterIds;
		// 			$ctrl.pendingRetailersMaster.load();
		// 		}
		// 	}
		// });

		$ctrl.completedRetailersMaster = new AutoQuery({
			url: 'QueryCustomerMergeList.json',
			criteria: {
				IsProcessed: true,
				IsMaster: true
			},
			pageSize: 10,
			take: 10,
			hideLeftNav: true,
			autoLoad: true
		});
		$ctrl.completedRetailersList = new AutoQuery({
			url: 'QueryCustomerMergeList.json',
			criteria: {
				IsProcessed: true,
			},
			pageSize: 10,
			take: 10,
			hideLeftNav: true,
			autoLoad: false
		});
		// $ctrl.completedMerges = new AutoQuery({
		// 	url: "QueryCustomerMergeList.json",
		// 	criteria: {
		// 		IsProcessed: true
		// 	},
		// 	take: 1000,
		// 	autoLoad: true,
		// 	onLoaded: (args) => {
		// 		if (args.results.length) {
		// 			$ctrl.completedMasterIds = args.results.filter(r => r.isMaster).map(obj => {return(obj.retailerId)}).join(",");
		// 			$ctrl.completedRetailersMaster.criteria.IdIn = $ctrl.completedMasterIds;
		// 			$ctrl.completedRetailersMaster.load();
		// 		}
		// 	}
		// });
	}
	$onInit() {
		const $ctrl = this;
	}
	setMaster(merge) {
		const $ctrl = this;
		$ctrl.buildMerge.map(m => {
			if (m.id == merge.id) m.isMaster = true;
			else m.isMaster = false;
		});
	}
	loadPendingRetailersChild(master) {
		const $ctrl = this;
		$ctrl.selectedMaster = master;
		// $ctrl.pendingChildIds = $ctrl.pendingMerges.results.filter(r => r.masterRetailerId == master.id).map(obj => {return(obj.retailerId)}).join(",");
		// $ctrl.pendingRetailersList.criteria.IdIn = $ctrl.pendingChildIds;
		$ctrl.pendingRetailersList.criteria.masterRetailerId = master.retailerId;
		$ctrl.pendingRetailersList.criteria.IdIn = null;
		$ctrl.pendingRetailersList.load();

	}
	loadCompletedRetailersChild(master) {
		const $ctrl = this;
		// $ctrl.completedChildIds = $ctrl.completedMerges.results.filter(r => r.masterRetailerId == master.id).map(obj => {return(obj.retailerId)}).join(",");
		// $ctrl.completedRetailersList.criteria.IdIn = $ctrl.completedChildIds;
		$ctrl.completedRetailersList.criteria.masterRetailerId = master.retailerId
		$ctrl.completedRetailersList.load();

	}
	processMerge() {
		const $ctrl = this;

		if ($ctrl.selectedMaster.id && $ctrl.pendingRetailersList.results.length) {
			return modals.confirm("Are you sure?", "Process this merge").result.then(function () {
				$ctrl.bus.send('ProcessCustomerMerge.json', {
					MasterId: $ctrl.selectedMaster.retailerId
				}).then(function(res) {
					modals.alert("Merge completed");
					//$ctrl.pendingMerges.load();
					$ctrl.pendingRetailersMaster.load();
					$ctrl.pendingRetailersList.criteria.IdIn = "NONE";
					$ctrl.pendingRetailersList.load();
				})
			});
		}
	}
	createMergeList() {
		const $ctrl = this;
		var master = $ctrl.buildMerge.filter(m => m.isMaster);
		if (master.length > 0) {
			let retailerIds = $ctrl.buildMerge.map(m => m.id);
			$ctrl.bus.send('CreateCustomerMergeList.json', {
				MasterRetailerId: master[0].id,
				RetailerIds: retailerIds
			}).then(function(res) {
				modals.alert("Merge list generated");
				$ctrl.buildMerge = [];
				$ctrl.pendingRetailersMaster.load();
			});

		} else {
			modals.alert("Please select one customer to be the master");
		}
	}
	selectCustomers() {
		let $ctrl = this;
		$ctrl.customerIds = [];

		return CustomerPicker({
			title: "Select Customers to Merge...",
			subTitle: "",
			applyTagsButtonText: false,
			single: false,
			viewSelections: false,
		}).then((result) => {
			$ctrl.bus.read("QueryRetailers.json", {
				IdIn: Object.keys(result).join(",")
			}).then(function (response) {
				$ctrl.buildMerge = response.data.results;
				$ctrl.buildMerge.map(function(obj) {
					obj.isMaster = false;
				});
			});
		});
	}
}

export default {
	bindings: {},
	controller: CustomerMergeController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
